// extracted by mini-css-extract-plugin
export var footer = "index-module--footer--uojx8";
export var footerContainer = "index-module--footer-container--MYDTW";
export var footerSmBlock = "index-module--footer-sm-block--pbP9A";
export var footerLogo = "index-module--footer-logo--o7e4g";
export var footerCopyRights = "index-module--footer-copy-rights--7ZkaC";
export var footerLinks = "index-module--footer-links--mo-+G";